// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2arnH","upload":"Small_upload__35NEd","imageWrap":"Small_imageWrap___R_6Z","removeBtn":"Small_removeBtn__2Ea6Y"};